(function () {
  'use strict';
  console.log("here in lang transformation cz -> sv")
  var ROOT_SELECTORS = '.cus-variant-table-wrapp, .blog__tag-item, .blog__tag-current, .info-box, .comparison-table, .cart-drawer, .collapsible-tabs-section-heading, .footer-link, .blog__post-tags-link, .navlink,.column-item__heading';

  // CZ -> SV dictionary
  var dict = {
    "Design od": "DIZAJN OD",
    "NÁDOBÍ S DNA": "RIAD S DNA",
    "OVĚŘENO":"OVERENÉ"
  };
  var keys = Object.keys(dict);

  function replaceInTextNode(node) {
    var text = node.nodeValue;
    if (!text) return;

    var changed = false;
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (text.indexOf(k) !== -1) {
        text = text.split(k).join(dict[k]);
        changed = true;
      }
    }
    if (changed) node.nodeValue = text;
  }

  function walkAndReplace(container) {
    var walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;

          var p = node.parentNode;
          if (!p) return NodeFilter.FILTER_REJECT;

          var tag = (p.nodeName || '').toLowerCase();
          if (tag === 'script' || tag === 'style' || tag === 'noscript') return NodeFilter.FILTER_REJECT;

          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    var n;
    while ((n = walker.nextNode())) replaceInTextNode(n);
  }

  function run() {
    // re-grab in case the element is injected later
    // find all matching roots (both wrappers + tag items)
  //   document.querySelectorAll('.countdown_annoucement_bar_wrapper_cmift3e9s005ik3odbhe7bmz2')
  // .forEach(el => {
  //   el.style.setProperty('display', 'none', 'important');
  // });
    var roots = document.querySelectorAll(ROOT_SELECTORS);
    if (!roots.length) return;

    roots.forEach(function (el) {
    walkAndReplace(el);
    });
  }

  // Run once after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Observe ONLY inside the wrapper for dynamic updates
  var obs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];

      if (m.type === 'characterData') {
        replaceInTextNode(m.target);
      } else if (m.addedNodes && m.addedNodes.length) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType === 3) {
            replaceInTextNode(node);
          } else if (node.nodeType === 1) {
            walkAndReplace(node);
          }
        }
      }
    }
  });

  // If wrapper exists now, observe it. If not, retry briefly.
function startObserver() {
  // document.querySelectorAll('.countdown_annoucement_bar_wrapper_cmift3e9s005ik3odbhe7bmz2')
  // .forEach(el => {
  //   el.style.setProperty('display', 'none', 'important');
  // });
  var roots = document.querySelectorAll(ROOT_SELECTORS);
  if (!roots.length) return false;

  roots.forEach(function (el) {
    obs.observe(el, { subtree: true, childList: true, characterData: true });
  });

  return true;
}

  if (!startObserver()) {
    // lightweight retry for late-loaded content
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      run();
      if (startObserver() || tries > 20) clearInterval(t); // ~10s max
    }, 500);
  }
})();

